export default __webpack_public_path__ + "static/media/check_bg_green.3ff3b14b.svg";